import { ROOT_CONTEXT, TraceFlags, isSpanContextValid, trace } from "@opentelemetry/api";
//#region src/extensions/otel/trace-context.ts
/**
* The span active on this thread right now, or nothing. Meant for a log processor: `@dxos/log`
* knows no tracer, so whoever serializes an entry captures this and the sink links the record to
* its trace. Only meaningful once a context manager is registered (see `OtelTraces`).
*/
var activeTraceContext = () => {
	const spanContext = trace.getActiveSpan()?.spanContext();
	return spanContext !== void 0 && isSpanContextValid(spanContext) ? {
		traceId: spanContext.traceId,
		spanId: spanContext.spanId
	} : void 0;
};
/** A context carrying a span captured on another thread, for a log record emitted here on its behalf. */
var contextForTrace = ({ traceId, spanId }) => trace.setSpanContext(ROOT_CONTEXT, {
	traceId,
	spanId,
	traceFlags: TraceFlags.SAMPLED,
	isRemote: true
});
//#endregion
export { contextForTrace as n, activeTraceContext as t };

//# sourceMappingURL=chunk-trace-context.mjs.map